/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { spendRulesOverviewGet } from "../funcs/spendRulesOverviewGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SpendRulesOverviewResult } from "../models/components/spendrulesoverviewresult.js";
import {
  GetSpendRulesOverviewRequest,
  GetSpendRulesOverviewSecurity,
} from "../models/operations/getspendrulesoverview.js";
import { unwrapAsync } from "../types/fp.js";
export type SpendRulesOverviewQueryData = SpendRulesOverviewResult;

export function prefetchSpendRulesOverview(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetSpendRulesOverviewRequest | undefined,
  security?: GetSpendRulesOverviewSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSpendRulesOverviewQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSpendRulesOverviewQuery(
  client$: GramCore,
  request?: GetSpendRulesOverviewRequest | undefined,
  security?: GetSpendRulesOverviewSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SpendRulesOverviewQueryData>;
} {
  return {
    queryKey: queryKeySpendRulesOverview({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function spendRulesOverviewQueryFn(
      ctx,
    ): Promise<SpendRulesOverviewQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(spendRulesOverviewGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySpendRulesOverview(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "overview", "get", parameters];
}
